import { CommissionState } from '../type';
import { COMMISSION_STATE } from '../constant';

export const convertCommissionStateToLabel = (state?: CommissionState) => {
  if (!state) return undefined;
  const commission_state_map = new Map<CommissionState, string>([
    [
      COMMISSION_STATE.PENDING,
      ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() }),
    ],
    [COMMISSION_STATE.END, ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() })],
    [
      COMMISSION_STATE.ACCEPTED,
      ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() }),
    ],
    [
      COMMISSION_STATE.ON_REFUND,
      ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() }),
    ],
    [
      COMMISSION_STATE.REFUNDED,
      ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() }),
    ],
    [
      COMMISSION_STATE.TASK_DONE,
      ET('mps2::membership::commission::state', { context: state.toLocaleLowerCase() }),
    ],
  ]);
  return commission_state_map.get(state);
};
